module.exports = __webpack_public_path__ + "img/i40_tourer.1ebd3fda.png";